import passiveEvents from 'util/passive-events'
import throttle from 'lodash/throttle'

let shouldMonitorScroll = true

/**
 * activate tab content when given an activate target node and a tab group id
 *
 * @param {HTMLElement} watchTargetNode
 * @param {Object} options
 */
function monitorScroll (watchTargetNode, options) {
    if (!watchTargetNode) {
        console.warn('====================================')
        console.warn(`please provide a htmlElement to monitor`)
        console.warn('====================================')

        return false
    }

    if (!options) {
        options = {
            offset: 0,
            callback: () => console.log(`entered`),
            shouldMonitorScroll: true,
            shouldStopOnceHit: true
        }
    }

    if (options.shouldMonitorScroll) {
        const watchTargetNodeRect = watchTargetNode.getBoundingClientRect()
        const windowHeight = window.innerHeight

        if (Math.floor(watchTargetNodeRect.top) < (windowHeight - (Math.floor(watchTargetNodeRect.height) * options.offset))) {
            // do callback here
            options.callback()

            if (options.shouldStopOnceHit) {
                shouldMonitorScroll = false
            }
        }
    }

    return false
}

function activateMap () {
    const mapNode = document.querySelector('.js-map')
    mapNode.classList.add('is-activeMap')
}

function watchMapPosition () {
    monitorScroll(mapImage, {
        offset: 0.5,
        callback: activateMap,
        shouldMonitorScroll,
        shouldStopOnceHit: true
    })
}

const mapImage = document.querySelector('.js-mapImage')

if (mapImage) {
    window.addEventListener('scroll', throttle(watchMapPosition, 100), passiveEvents ? { passive: true } : false)
}
